let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("86HE4")).then(() => parcelRequire('aJyzh'));